import type { PlayState } from "../../core/game";
import { drawPlayfield } from "./gameView";
import { drawText, type DrawContext } from "../text";
import { isBlinking } from "./titleView";

export function drawGameOver(
  rc: DrawContext,
  play: PlayState,
  wallPass: boolean,
  hiScore: number,
): void {
  const { width, height, cell } = rc.layout;

  // Arka planda son sahne + hafif saydam perde
  drawPlayfield(rc, play, wallPass);
  rc.ctx.fillStyle = "rgba(155, 187, 69, 0.82)";
  rc.ctx.fillRect(0, 0, width, height);

  const fs = Math.max(12, Math.floor(cell * 0.8));
  drawText(rc, "GAME OVER", width / 2, height * 0.32, fs);
  drawText(rc, `SKOR  ${play.score}`, width / 2, height * 0.46, Math.floor(fs * 0.6));

  if (play.score >= hiScore && play.score > 0) {
    drawText(rc, "YENI REKOR!", width / 2, height * 0.54, Math.floor(fs * 0.55));
  } else {
    drawText(rc, `REKOR ${hiScore}`, width / 2, height * 0.54, Math.floor(fs * 0.55));
  }

  if (isBlinking(1.2)) {
    drawText(rc, "TEKRAR: A/ENTER", width / 2, height * 0.7, Math.floor(fs * 0.5));
  }
  drawText(rc, "MENU: B/ESC", width / 2, height * 0.78, Math.floor(fs * 0.5));
}
